import { reloadBrowserWindow } from "lib/browser-reload";

export const standalone =
    (window.navigator as any).standalone === true ||
    (typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches);

export function initRefreshOnStandalone() {
    if (typeof window.matchMedia !== "function") return;

    const standaloneQuery = window.matchMedia("(display-mode: standalone)");
    // Safari mis-implements media query causing this to come back undefined. See MDN:
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
    standaloneQuery.addEventListener?.("change", () => {
        // Because moving from PWA to browser should technically also disable persistence, I opted to make this action
        // always reload the window, so that Firestore can re-initialize properly in both cases.
        reloadBrowserWindow("Standalone mode was switched.  Reloading...");
    });
}
